module.exports = __webpack_public_path__ + "img/arrow-down.488dbd13.svg";